import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.mora10.com.br',
})

export default api;